import React from 'react';
import { IconSVG } from '../../../components';
import { getAccentColor } from '../../../utils';

const accentColor = getAccentColor();

const Claim: React.FC = () => (
  <IconSVG width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.336 12.9053C15.596 12.9053 14.91 13.1203 14.315 13.4713L12.457 11.6113L11.043 13.0263L12.902 14.8843C12.551 15.4803 12.336 16.1643 12.336 16.9053C12.336 19.1123 14.127 20.9053 16.336 20.9053C17.076 20.9053 17.761 20.6913 18.356 20.3393L15.629 17.6123L17.043 16.1983L19.77 18.9243C20.121 18.3293 20.336 17.6443 20.336 16.9053C20.336 14.6953 18.545 12.9053 16.336 12.9053Z"
      fill={accentColor}
    />
    <path
      d="M4.33594 8.9053C5.07594 8.9053 5.76094 8.6913 6.35494 8.3393L8.21394 10.1983L9.62794 8.7843L7.76994 6.9243C8.12094 6.3293 8.33594 5.6453 8.33594 4.9043C8.33594 2.6943 6.54494 0.904297 4.33594 0.904297C3.59594 0.905297 2.90994 1.1193 2.31594 1.4713L5.04294 4.1983L3.62894 5.6113L0.901937 2.8843C0.550937 3.4803 0.335938 4.1643 0.335938 4.9043C0.335938 7.1113 2.12694 8.9053 4.33594 8.9053Z"
      fill={accentColor}
    />
    <path
      d="M8.7497 13.9053L16.5427 6.1123L17.3357 6.9043L20.3357 2.9043L18.3357 0.904297L14.3357 3.9043L15.1287 4.6973L7.3357 12.4913L5.0427 10.1983L3.6287 11.6123L4.9217 12.9053L0.628699 17.1983C0.237699 17.5893 0.237699 18.2213 0.628699 18.6123L2.6287 20.6123C3.0197 21.0033 3.6517 21.0033 4.0427 20.6123L8.3357 16.3193L9.6287 17.6113L11.0427 16.1973L8.7497 13.9053Z"
      fill="black"
    />
  </IconSVG>
);

export default Claim;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/icons/Claim.tsx